import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import Util from '@/util'

// modules
import permission from './modules/permission'
import agent from './modules/agent'
import customer from './modules/customer'
import chat from './modules/chat'
import chatbot from './modules/chatbot'
import chatbotTemplate from './modules/chatbotTemplate'
import settings from './modules/settings'

// socket modules
import customWebSocket from './modules/webSocket'
import callWebsocket from './modules/callWebsocket'
import callStatusSocket from './modules/callWebsocket/status'
import ticketWebSocket from './modules/ticketWebSocket'
import callApiWebsocket from './modules/callApiWebsocket'

import callAgentStatus from './modules/call/agentStatus'
import ticket from './modules/ticket'
import cafe24 from './modules/cafe24'
import callStatus from './modules/call/callStatus'
import talkOperation from './modules/talkOperation'
import callServer from './modules/call/callServer'
import inquiry from './modules/inquiry'

import marketingLine from './modules/marketingLine'
import marketingRich from './modules/marketingRich'
import marketingPush from './modules/marketingPush'
// import agentWebsocket from './modules/agentWebSocket'
import callConsultStatus from './modules/report/callConsultStatus'

import reservation from './modules/reservation'

import eventBus from '@/event_bus'

Vue.use(Vuex)

const LOGIN = 'LOGIN'
const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
const LOGOUT = 'LOGOUT'
// const CLEAR_ROLE = 'CLEAR_ROLE'  // 기존 사용자들 처리할 때, 필요한 기능일까봐 아직 삭제 X
const LOCAL_STORAGE_TOKEN_KEY = 'token'
const REFRESH_TOKEN_KEY = 'refreshToken'
const IS_AUTHORIZED = 'isAuthorized'

export const store = new Vuex.Store({
  modules: {
    permission,
    agent,
    customer,
    chat,
    chatbot,
    chatbotTemplate,
    settings,
    customWebSocket,
    callWebsocket,
    callStatusSocket,
    ticketWebSocket,
    callApiWebsocket,
    callAgentStatus,
    ticket,
    cafe24,
    callStatus,
    talkOperation,
    callServer,
    inquiry,
    callConsultStatus,
    marketingLine,
    marketingPush,
    marketingRich,
    reservation
  },

  state: {
    layout: 'default-layout',
    isLoggedIn: localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY),
    isAdministratorRole: localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY) && Util.parseLoginToken().admin
  },
  mutations: {
    SET_LAYOUT (state, payload) {
      state.layout = payload + '-layout'
    },
    LOGIN (state) {
      state.pending = true
    },
    REFRESH (state) {
      state.pending = true
    },
    LOGIN_SUCCESS (state) {
      state.isLoggedIn = true
      state.pending = false
      localStorage.setItem(IS_AUTHORIZED, 'true')
    },
    REFRESH_SUCCESS (state) {
      state.pending = false
    },
    LOGOUT (state) {
      state.isLoggedIn = false
      localStorage.setItem(IS_AUTHORIZED, 'false')
    },
    SET_DATA (state, { key, boolean }) {
      state[key] = boolean
    }
    // CLEAR_ROLE (state) {
    //   state.isAgentRole = false
    //   state.isManagerRole = false
    //   state.isSystemRole = false
    //   state.isClientRole = false
    //   state.isMessageRole = false
    //   state.isAdministratorRole = false
    //   state.isIcomsysRole = false
    // }
  },
  actions: {
    login: function ({commit}, loginParam) {
      let loginResponse = {
        isSuccess: false,
        data: {}
      }
      commit(LOGIN)
      return axios({
        method: 'post',
        url: '/auth/login',
        data: loginParam,
        headers: {'X-Requested-With': 'XMLHttpRequest'}
      })
        .then((res) => {
          try {
            const responseData = res.data
            if (res.status === 200 && responseData.token) {
              const token = responseData.token
              localStorage.setItem(LOCAL_STORAGE_TOKEN_KEY, token)
              localStorage.setItem(REFRESH_TOKEN_KEY, responseData.refreshToken)
              loginResponse.isSuccess = true
              commit('setAgentState', Util.parseLoginToken())
              if (process.env.TARGET !== 'outaigate') {
                commit('setCallServer', Util.parseLoginToken())
              }
              commit(LOGIN_SUCCESS)
            }
            loginResponse.data = res.data

            return loginResponse
          } catch (e) {
            console.log(e)
          }
        }).catch((result) => {
          loginResponse.isSuccess = false
          loginResponse.data = {code: 401}
          const errorCodes = [-1, -5, -12, -15]
          if (result.response && errorCodes.indexOf(result.response.data.code) > -1) {
            let getBtnCount = 1
            let getButtonEvent = () => {}
            let messageHTML = `<p class="txt">${result.response.data.message}</p>`

            if (result.response.data.code === -5) {
              loginParam.tokenKey = result.response.data.data.tokenKey
              getBtnCount = 2
              getButtonEvent = () => { eventBus.$emit('force-login-event', loginParam) }
              messageHTML = `<p class="txt">すでにログイン中です。<br/>強制的にログアウトしますか?</p>`
            }
            if (result.response.data.code === -1) {
              getBtnCount = 1
              messageHTML = `<p class="txt">IDまたはパスワードが間違っています。<br /><span style="color:#919191">5回以上エラーが発生した場合、 <br/>アカウントがロックされる可能性があります。</span></p>`
            }
            if (result.response.data.code === -12) {
              getBtnCount = 1
              messageHTML = `<p class="txt">加入されたメールアドレスを通じて<br/>パスワードの再設定が可能です。<br/><span style="color:#ff8c8c;font-weight:bold">(5回超過)</span><span style="display:block;color:#919191;padding-top:12px;font-size:13px">メールを受信できない場合は、管理者にお問い合わせください。</span></p>`
            }

            eventBus.$emit('DialogPopup', {
              useDialog: true,
              getBtnCount,
              getButtonEvent,
              messageHTML
            })
          }
          return loginResponse
        })
    },
    forceLogin: function ({commit}, forceLoginParameters) {
      return axios({
        method: 'post',
        url: '/api/external/forceLogout',
        data: forceLoginParameters,
        headers: {'X-Requested-With': 'XMLHttpRequest'}
      })
    },
    setLogout: function ({commit}) {
      commit(LOGOUT)
      // commit(CLEAR_ROLE)
      commit('forceCallApiCloseSubscription')
      commit('CLOSE_CALL')
      localStorage.removeItem(LOCAL_STORAGE_TOKEN_KEY)
      localStorage.removeItem(REFRESH_TOKEN_KEY)
      localStorage.removeItem('agent-menus')
      localStorage.removeItem('close-banner')
      localStorage.removeItem('selectedType')
      localStorage.removeItem('TICKET_LIST_OPTION')
      localStorage.removeItem('CUSTOMER_LIST_OPTION')
      localStorage.removeItem('MARKETING_LIST_OPTION')
      localStorage.removeItem('lookInBrandResult')
      commit('CLEAR_CALL_STATUS')
      commit('CLEAR_CALL_DETAILS')
      commit('CLEAR_CALL_AGENT_LIST')
      commit('CLEAR_AGENT')
      commit('CLEAR_CHAT')
      commit('FAIL_CONNECT')
      commit('closeDashboardWin')
      commit('CLOSE_STATUS')
      commit('setCallMode', 'NEOMECCA')
      commit('setNowPathId', null)
    },
    logout: function ({commit, dispatch}, param) {
      return axios({
        method: 'post',
        url: '/auth/logout',
        data: {
          agentId: Util.parseLoginToken().agentId,
          tokenKey: Util.parseLoginToken().tokenKey
        },
        headers: {'X-Requested-With': 'XMLHttpRequest'}
      }).then((res) => {
        dispatch('setLogout')
        commit('setCheckPaths', [])
        commit('setPathActions', [])
        if (param && !param.busOn) {
          Object.keys(eventBus._events).map((d) => {
            if (d !== 'DialogPopup' && d !== 'ClosePopup') {
              eventBus.$off(d)
            }
          })
        }
        return res
      })
    },
    forceLogout: function ({commit, dispatch}, flag) {
      dispatch('setLogout')
      commit('setCheckPaths', [])
      commit('setPathActions', [])
      Object.keys(eventBus._events).map((d) => {
        if (d !== 'DialogPopup' && d !== 'ClosePopup') {
          eventBus.$off(d)
        }
      })
      return true
    },
    refresh: function ({commit}) {
      commit('REFRESH')
      return axios({
        method: 'get',
        url: '/auth/refresh',
        headers: {'X-Requested-With': 'XMLHttpRequest'}
      }).then((res) => {
        const responseData = res.data
        if (res.status === 200 && responseData.token) {
          const token = responseData.token
          localStorage.setItem(LOCAL_STORAGE_TOKEN_KEY, token)
          localStorage.setItem(REFRESH_TOKEN_KEY, responseData.refreshToken)
          commit('setAgentState', Util.parseLoginToken())
          commit('setCallServer', Util.parseLoginToken())
        }
        commit('REFRESH_SUCCESS')
        return res
      })
    }
  },
  getters: {
    layout (state) {
      return state.layout
    },
    isLoggedIn (state) {
      return state.isLoggedIn
    },
    isAdministratorRole (state) {
      return state.isAdministratorRole
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js